module.exports = __webpack_public_path__ + "static/media/logo-header.cdbbb44c.webp";